(() => {
  // app/scripts/price-range-slider-component.js
  var PriceRangeCheckboxes = class extends HTMLElement {
    connectedCallback() {
      this.gteInput = this.querySelector(".js-price-gte");
      this.lteInput = this.querySelector(".js-price-lte");
      this.addEventListener("change", (e) => {
        if (!e.target.closest(".js-price-range-option")) return;
        const checked = [
          ...this.querySelectorAll(".js-price-range-option")
        ].filter((el) => el.checked);
        const gtes = checked.map((el) => el.dataset.gte);
        const ltes = checked.map((el) => el.dataset.lte);
        this.gteInput.value = !checked.length || gtes.includes("") ? "" : String(Math.min(...gtes.map(Number)));
        this.lteInput.value = !checked.length || ltes.includes("") ? "" : String(Math.max(...ltes.map(Number)));
        const form = this.gteInput.form;
        if (form?.requestSubmit) form.requestSubmit();
        else
          form?.dispatchEvent(
            new Event("submit", { bubbles: true, cancelable: true })
          );
      });
    }
  };
  if (!customElements.get("price-range-checkboxes")) {
    customElements.define("price-range-checkboxes", PriceRangeCheckboxes);
  }
})();
